import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from "@angular/core";
import { MarcaService } from "../../../../../shared/services/marca.service";
import { VehiclesService } from "../../../../../shared/services/vehicles.service";
import { TiposerviciosDocumentosService } from "../../../../../shared/services/tiposerviciosdocumento.service";
import { Modelo, ModelosService } from "../../../../../shared/services/modelos.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbAccordion, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectComponent } from "@ng-select/ng-select";
import { NgbdSortableHeader } from "../../../../../shared/directives/NgbdSortableHeader";
import { ActivatedRoute } from "@angular/router";
import { Utils } from "../../../../../shared/utils/Utils";
import jsPDF from "jspdf";
declare var require;
const Swal = require("sweetalert2");
@Component({
  selector: 'app-modelo-inactivo',
  templateUrl: './modelo-inactivo.component.html',
  styleUrls: ['./modelo-inactivo.component.scss']
})
export class ModeloInactivoComponent {
  @ViewChild("inputServicio") inputServicio!: ElementRef;
  @ViewChild("inputPlaca") inputPlaca!: ElementRef;
  @ViewChild("inputInterno") inputInterno!: ElementRef;
  @ViewChild("inputEmpresa") inputEmpresa!: NgSelectComponent;
  @ViewChild("inputClase") inputClase!: NgSelectComponent;
  @ViewChild("inputMarca") inputMarca!: NgSelectComponent;
  @ViewChild("inputModelo") inputModelo!: NgSelectComponent;
  @ViewChild("inputRelacion") inputRelacion!: NgSelectComponent;
  @ViewChild("inputPassword") inputPassword!: ElementRef;
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;


  pageSize1: number = 5; 
  page1: number = 1;
  totalItems: number;
  sortDirection: 'asc' | 'desc' = 'asc';
  sortedColumn: string = '';
  formNuevo: FormGroup;
  validate: boolean = false;
  errores: any = {};
  relaciones: any;
  modelos: any;
  editMode: boolean;
  botonListarDisponible: boolean = false;
  modelo: any;
  formModelo: FormGroup;
  modeloSeleccionado: any;
    filteredTableItems: any[] = [];
  public searchText: string = ''; // Texto de búsqueda



  // Hacer que el calendario se cierre al hacer clic fuera del componente
  @HostListener("document:click", ["$event"])
  clickout(event: MouseEvent) {
    const calendar = document.querySelector(".ngb-datepicker");
    if (calendar && !calendar.contains(event.target as Node)) {
      // Aquí el calendario se cierra automáticamente
      // Este comportamiento está controlado por autoClose='outside'
    }
  }
  constructor(   
    private modeloService: ModelosService,
    private fb: FormBuilder,
   
  ) { }

  maxDate: string;
  minDate: string;

  ngOnInit() {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    this.minDate = formattedDate;
    this.maxDate = formattedDate;

    this.listarModelos();


    this.formModelo = this.fb.group({
    id: [null],
    modelo: [null],
    estado: [1],
    usuario: ['admin'],

    });

  }


 
listarModelos(): void {
  this.modeloService.getModelosInactivos().subscribe({
    next: (data) => {
      this.modelos = data || []; // Asegúrate de tener siempre un arreglo
      if (this.modelos.length > 0) {
        // console.log('✅ Modelos cargados:', this.modelos);
      } else {
        console.log('⚠️ No se encontraron modelos.');
      }
      this.filteredTableItems = [...this.modelos]; // <-- Corregido: usar this.modelos
    },
    error: (error) => {
      console.error('❌ Error cargando modelos:', error);
    }
  });
}
  
  activarModelo(id: number) {
    Swal.fire({
      title: "ACTIVAR",
      text: `¿Desea activar el modelo con ID: ${id}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.modeloService.activarModelo(id).subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "¡Modelo activado!",
              text: "El estado del modelo ha sido actualizado correctamente.",
              confirmButtonText: "Aceptar",
            }).then(() => {
              this.listarModelos(); // 🔥 Recargar la lista después de activar
            });
          },
          error: (error) => {
            const mensaje = error?.error?.message || "No se pudo activar el modelo";
  
            Swal.fire({
              icon: "error",
              title: "Error",
              text: mensaje,
              confirmButtonText: "Aceptar",
            });
  
            console.error("Error al activar modelo:", error);
          },
        });
      }
    });
  }
  
  
  
  

   exportToPDF(tableId:string,nameFile:string,titleFile:string) {
    Utils.exportToPDF(tableId, nameFile,titleFile);
    }
  
  
    exportarExcel(tableId:string,nameFile:string) {
      Utils.exportVisibleTableToExcel(tableId, nameFile);
    }
  
   sortData(column: string) {
    if (this.sortedColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }

    this.modelos.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];

      if (typeof valueA === 'string') {
        return this.sortDirection === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      } else {
        return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
      }
    });
  }
  
  filterData() {
  const search = this.searchText?.toLowerCase() || '';
  this.filteredTableItems = this.modelos.filter(modelo =>
    String(modelo.modelo).toLowerCase().includes(search)
  );
  this.page1 = 1; // Reinicia a la primera página al filtrar
}

  
   
}
